import { HTMLAttributes, PropsWithChildren, Ref } from 'react'
import classNames from 'classnames'

import { TextStyle } from '../sharedTypes'

import './index.scss'

// Extends HTMLAttributes so native span props pass through — notably the
// onMouseOver/onFocus/onTouchStart/aria-describedby handlers MUI's Tooltip clones onto its
// child (CollapsedTextTooltip uses a Text as the trigger; MUI hover fires onMouseOver, not
// onMouseEnter, so without the passthrough the tooltip would never open).
interface TextProps extends HTMLAttributes<HTMLSpanElement> {
  link?: boolean
  styleType: TextStyle
  ref?: Ref<HTMLSpanElement>
}

const Text = ({
  children,
  className,
  link,
  styleType,
  ref,
  ...rest
}: PropsWithChildren<TextProps>) => {
  return (
    <span
      className={classNames(`populus-text-${styleType}`, link && 'link', className)}
      ref={ref}
      {...rest}
    >
      {children}
    </span>
  )
}

Text.displayName = 'Text'

export { Text }
